var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.services
    ? _c("div", { staticClass: "row pt-2 pb-2" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c(
              "transition-group",
              {
                attrs: {
                  appear: "",
                  name: "staggered-fade",
                  tag: "div",
                  css: false
                },
                on: { "before-enter": _vm.beforeEnter, enter: _vm.enter }
              },
              _vm._l(_vm.services, function(service, index) {
                return _c(
                  "div",
                  {
                    key: service.id,
                    class: _vm.platformActionClass,
                    attrs: { "data-index": index, id: "id-" + service.id }
                  },
                  [
                    _c("employee-hub-service", {
                      staticClass: "service-object",
                      attrs: {
                        "service-id": service.id,
                        "platform-category": _vm.platformCategory,
                        "current-user-access-token":
                          _vm.authResponse.accessToken
                      }
                    }),
                    _vm._v(" "),
                    _vm.services.length > 1
                      ? _c(
                          "div",
                          { staticClass: "row no-gutters text-right" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-12 bg-white pr-md-5 pr-3 pb-4 eh-services-index"
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(++index) +
                                    " of " +
                                    _vm._s(_vm.services.length) +
                                    " Services\n\t\t\t\t\t"
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.services.length !== index && _vm.services.length > 1
                      ? _c("hr", { staticClass: "horizontal-line" })
                      : _vm._e()
                  ],
                  1
                )
              }),
              0
            )
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d8336e7e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8336e7e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service-browser/DisplayServices.vue
// module id = null
// module chunks = 